import { type RefObject, useEffect, useState } from 'react'
import { type MenuProps } from '@mui/material'
import { rem } from 'polished'

const DEFAULT_HOURS_DROPDOWN_MAX_HEIGHT = 400
const OFFSET_FORM_HEIGHT = 200

type UseDatetimeDropdownMenuReturnType = {
  getDropdownMenuProps: () => Partial<MenuProps>
}

export const useDatetimeDropdownMenu = (
  formRef: RefObject<HTMLFormElement | null>,
): UseDatetimeDropdownMenuReturnType => {
  const [dropdownHeight, setDropdownHeight] = useState(DEFAULT_HOURS_DROPDOWN_MAX_HEIGHT)

  const getDropdownMenuProps = () =>
    ({
      slotProps: {
        paper: {
          style: {
            maxHeight: rem(dropdownHeight),
          },
        },
      },
    }) satisfies Partial<MenuProps>

  useEffect(() => {
    if (formRef.current) {
      const formHeight = formRef.current.clientHeight
      const calculatedDropdownHeight = formHeight - OFFSET_FORM_HEIGHT

      setDropdownHeight(calculatedDropdownHeight > 0 ? calculatedDropdownHeight : DEFAULT_HOURS_DROPDOWN_MAX_HEIGHT)
    }
  }, [formRef])

  return { getDropdownMenuProps }
}
